import axios from "axios";
import { CldContext, CldImage } from "cloudinary-vue";
import articleModal from "../articleModal/index.vue";

export default {
  name: "articlesBySearchSection",
  components: {
    CldContext,
    CldImage,
    articleModal
  },
  data() {
    return {
      min: 1,
      max: 1000,
      minValue: 1,
      maxValue: 1000,
      step: 5,
      totalSteps: 0,
      percentPerStep: 1,
      trackWidth: null,
      isDragging: false,
      pos: {
        curTrack: null,
      },

      colorImg: "",
      allArticles: [],
      pageSize: 16,
      currentPage: 1,
      productUser: [],
      picNumber: 0,
     
      sortedData: [],
      selectedFilters: [],
      dataToFilter: [],
      FilterAll: this.$route.query.search,
      modelDisponible: "",
      quantiteMax: 1,
      quantiteMin: 1,
      btnValue: "",
      selectDetailsSize: "",
      detailsElement: [],
      detailsElementSize: [],
      detailsElementPointure: [],
      detailsElementDimmension: [],
      dimmensionLargeur: 0,
      dimmensionLongueur: 0,
      maxW: 0,
      maxH: 0,
      idSelectedElement: "",
      // sizeProduct:["x","y"],
      model: {
        quantite: 1,
      },
    };
  },
  mounted() {
    // calc per step value
    this.totalSteps = (this.max - this.min) / this.step;

    // percent the track button to be moved on each step
    this.percentPerStep = 100 / this.totalSteps;
    // console.log('percentPerStep', this.percentPerStep)

    // set track1 initilal
    document.querySelector(".track1").style.left =
      this.valueToPercent(this.minValue) + "%";
    // track2 initial position
    document.querySelector(".track2").style.left =
      this.valueToPercent(this.maxValue) + "%";
    // set initila track highlight
    this.setTrackHightlight();

    var self = this;

    ["mouseup", "mousemove"].forEach((type) => {
      document.body.addEventListener(type, (ev) => {
        // ev.preventDefault();
        if (self.isDragging && self.pos.curTrack) {
          self[type](ev, self.pos.curTrack);
        }
      });
    });

    [
      "mousedown",
      "mouseup",
      "mousemove",
      "touchstart",
      "touchmove",
      "touchend",
    ].forEach((type) => {
      document.querySelector(".track1").addEventListener(type, (ev) => {
        ev.stopPropagation();
        self[type](ev, "track1");
      });

      document.querySelector(".track2").addEventListener(type, (ev) => {
        ev.stopPropagation();
        self[type](ev, "track2");
      });
    });

    // on track clik
    // determine direction based on click proximity
    // determine percent to move based on track.clientX - click.clientX
    document.querySelector(".track").addEventListener("click", function(ev) {
      ev.stopPropagation();
      self.setClickMove(ev);
    });

    document
      .querySelector(".track-highlight")
      .addEventListener("click", function(ev) {
        ev.stopPropagation();
        self.setClickMove(ev);
      });
  },
  async created() {
    this.getElements();
    console.log("head",this.$route.query.type)
    // await this.$loadScript("./js/jqueryV1.min.js");
    // await this.$loadScript("./js/jquery.zoom.js");
    // $(".ex1").zoom();
  },
  watch: {
    $route(to, from) {
      this.getElements();
    },
  },
  // computed: {
  //   sortedElement: function() {
  //     return this.allArticles.filter((row, index) => {
  //       let start = (this.currentPage - 1) * this.pageSize;
  //       let end = this.currentPage * this.pageSize;
  //       if (index >= start && index < end) return true;
  //     });
  //   },
  // },
  methods: {
    modelContent(element, index) {
      this.$store.state.product.productDetail=element
      this.$store.state.product.productModalState=true
    },
    moveTrack(track, ev) {
      let percentInPx = this.getPercentInPx();
      let trackX = Math.round(
        this.$refs._vpcTrack.getBoundingClientRect().left
      );
      let clientX = ev.clientX;
      let moveDiff = clientX - trackX;

      let moveInPct = moveDiff / percentInPx;
      // console.log(moveInPct)

      if (moveInPct < 1 || moveInPct > 100) return;
      let value =
        Math.round(moveInPct / this.percentPerStep) * this.step + this.min;
      if (track === "track1") {
        if (value >= this.maxValue - this.step) return;
        this.minValue = value;
      }

      if (track === "track2") {
        if (value <= this.minValue + this.step) return;
        this.maxValue = value;
      }

      this.$refs[track].style.left = moveInPct + "%";
      this.setTrackHightlight();
    },
    mousedown(ev, track) {
      if (this.isDragging) return;
      this.isDragging = true;
      this.pos.curTrack = track;
    },

    touchstart(ev, track) {
      this.mousedown(ev, track);
    },

    mouseup(ev, track) {
      if (!this.isDragging) return;
      this.isDragging = false;
    },

    touchend(ev, track) {
      this.mouseup(ev, track);
    },

    mousemove(ev, track) {
      if (!this.isDragging) return;
      this.moveTrack(track, ev);
    },

    touchmove(ev, track) {
      this.mousemove(ev.changedTouches[0], track);
    },

    valueToPercent(value) {
      return ((value - this.min) / this.step) * this.percentPerStep;
    },

    setTrackHightlight() {
      this.$refs.trackHighlight.style.left =
        this.valueToPercent(this.minValue) + "%";
      this.$refs.trackHighlight.style.width =
        this.valueToPercent(this.maxValue) -
        this.valueToPercent(this.minValue) +
        "%";
    },

    getPercentInPx() {
      let trackWidth = this.$refs._vpcTrack.offsetWidth;
      let oneStepInPx = trackWidth / this.totalSteps;
      // 1 percent in px
      let percentInPx = oneStepInPx / this.percentPerStep;

      return percentInPx;
    },

    setClickMove(ev) {
      let track1Left = this.$refs.track1.getBoundingClientRect().left;
      let track2Left = this.$refs.track2.getBoundingClientRect().left;
      // console.log('track1Left', track1Left)
      if (ev.clientX < track1Left) {
        this.moveTrack("track1", ev);
      } else if (ev.clientX - track1Left < track2Left - ev.clientX) {
        this.moveTrack("track1", ev);
      } else {
        this.moveTrack("track2", ev);
      }
    },

    detailArticlePage(id) {
      return "/detail-article?id_article=" + id;
    },

    // updateCountry (person, country) {
    //   person.country = country;
    // },
  
   
   
    sortedElement() {
      this.sortedData = this.dataToFilter.filter((row, index) => {
        let start = (this.currentPage - 1) * this.pageSize;
        let end = this.currentPage * this.pageSize;
        if (index >= start && index < end) return row;
      });
    },
    filterDataArray(MethodNameFilter) {
      var dataFilterData = this.allArticles;
      if (this.selectedFilters.includes(MethodNameFilter)) {
        this.selectedFilters.splice(
          this.selectedFilters.indexOf(MethodNameFilter),
          1
        );
      }
      this.selectedFilters.push(MethodNameFilter);
      this.selectedFilters.forEach((element) => {
        // if (element === "filterCategorie") {
        //   dataFilterData = this.filterCategorie(dataFilterData);
        // }
        if (element === "filterAll") {
          dataFilterData = this.filterAll(dataFilterData);
        }
      });
      // this.dataToFilter = this.sortedData;
      this.sortedElement();
    },
    // filterCategorie: function(dataFilterData) {
    //   console.log("test",dataFilterData)
    //   this.dataToFilter = dataFilterData.filter((element) => {
    //     if (this.model.FilterCategorie == "Tous") {
    //       return element;
    //     } else if (element.category == this.model.FilterCategorie) {
    //       return element;
    //     }
    //   });
    //   return this.dataToFilter;
    // },
    filterAll(dataFilterData) {
      this.dataToFilter = dataFilterData.filter((element) => {
        if (this.FilterAll == "") {
          return element;
        } else {
          return this.FilterAll.toLowerCase()
            .split(" ")
            .every((v) => element.label.toLowerCase().includes(v));
        }
      });
      return this.dataToFilter;
    },
    nextProduct() {
      this.pageSize = this.pageSize + 8;
      this.getElements()
    },
    currentArticleNumber() {
      if (this.allArticles.length <= 16) {
        return this.allArticles.length;
      } else {
        return 16;
      }
    },
    styleImgSrc: function(element) {
      var imgSrc1, imgSrc2;
      if (element.typeArticle == "vetements") {
        imgSrc1 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[0] +
          ")";
        imgSrc2 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.vetements[0].image[1] +
          ")";
      } else if (element.typeArticle == "chaussure") {
        imgSrc1 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[0] +
          ")";
        imgSrc2 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.chaussure[0].image[1] +
          ")";
      } else if (element.typeArticle == "tapis") {
        imgSrc1 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[0] +
          ")";
        imgSrc2 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.tapis[0].image[1] +
          ")";
      } else if (element.typeArticle == "autre") {
        imgSrc1 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[0] +
          ")";
        imgSrc2 =
          "url(https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" +
          element.autre[0].image[1] +
          ")";
      }
      return {
        "--imgSrc": imgSrc1,
        "--imgSrc-hover": imgSrc2,
      };
    },
    deleteWishlist(id) {
      var product = {
        user: window.localStorage.getItem("Giftstore-U"),
        product: id,
      };
      console.log("fdshgfhgjsf", product);
      axios
        .post(
          "https://giftstore-blog.herokuapp.com/api/user/wishlist/remove",
          product
        )
        .then((response) => {
          this.getElements();
          this.$toast.open({
            message: "Produit bien supprimé de la wishlist ",
            type: "success",
            // position: "top-right",
            // all of other options may go here
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);
          this.$toast.open({
            message: "Error lors de la suppression du produit",
            type: "error",
            // position: "top-right",
            // all of other options may go here
          });
        });
    },
    addWishlist(id) {
      var product = {
        user: window.localStorage.getItem("Giftstore-U"),
        product: id,
      };
      if (window.localStorage.getItem("Giftstore-U")) {
        axios
          .post(
            "https://giftstore-blog.herokuapp.com/api/user/wishlist/add",
            product
          )
          .then((response) => {
            this.$store.commit("setUserInfo", response.data.user);
            console.log(response);
            this.getElements();
            this.$toast.open({
              message: "Produit bien ajouté à la wishlist",
              type: "success",
              // position: "top-right",
              // all of other options may go here
            });
          })
          .catch((error) => {
            console.error("There was an error!", error);
            this.$toast.open({
              message: "Error lors de l'ajout du produit",
              type: "error",
              // position: "top-right",
              // all of other options may go here
            });
          });
      } else {
        this.$toast.open({
          message: "Vous devez être connecter",
          type: "info",
        });
      }
    },
    getElements() {
      console.log(this.$route.query.type);
      axios
        .get(
          "https://giftstore-blog.herokuapp.com/api/product/get/all"
            
        )
        // this.$route.query.filtre
        .then((response) => {
          console.log("dataArticle", response);
          response.data.fetchedArticles
          this.allArticles = [];
          this.allArticles = response.data.fetchedArticles;
          this.dataToFilter = this.allArticles;
          this.sortedElement();
          this.filterDataArray("filterAll")
          console.log("articles", this.allArticles);
        })
        .catch((error) => {
          this.allArticles = [];
          this.errorMessage = error.message;
          console.error("There was an error!", error);
        });
    },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    imgColor(img) {
      return (
        "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/" + img
      );
    },
    GetProductNumber() {
      //extracting the theme number from local storage
      if (localStorage.getItem("ProductNumber") === null) {
        return 0;
      } else {
        return localStorage.getItem("ProductNumber");
      }
    },

    addedwhislit(id) {
      // ._id
      console.log(this.$store.getters.getUserInfo.wishList);
      var wishListTab = [];
      if (this.$store.getters.getUserInfo.wishList == "undefined") {
        wishListTab = this.$store.getters.getUserInfo.wishList;
        for (let i = 0; i <= wishListTab.length - 1; i++) {
          console.log("tetetetet", wishListTab[i], id);
          if (wishListTab[i] == id) {
            return false;
          }
        }
        return true;
      } else {
        return true;
      }
    },
    addedElement(id) {
      var ProNum = this.GetProductNumber();
      var idElement;
      for (let i = 1; i <= ProNum; i++) {
        idElement = JSON.parse(localStorage.getItem("product" + i));
        if (idElement.id == id) {
          return false;
        }
      }
      return true;
    },
    deleteArticle(id) {
      var TabThemes = [];
      var nb = this.GetProductNumber();
      window.localStorage.removeItem("ProductNumber");
      var idElement;
      for (var k = 1; k <= nb; k++) {
        idElement=JSON.parse(localStorage.getItem("product" + k))
        if( idElement.id != id) {
          TabThemes.push(JSON.stringify(idElement));
        }
        window.localStorage.removeItem("product" + k);
      }
      for (var j = 1; j <= TabThemes.length; j++) {
        localStorage.setItem("product" + j, TabThemes[j - 1]);
      }
      localStorage.setItem("ProductNumber", TabThemes.length);
      this.getElements();
      this.$toast.open({
        message: "Produit supprimé au Panier",
        type: "success",
      });
      this.$store.commit("setbasket", TabThemes);
    },
    addArticle(id) {
      let ProNum = this.GetProductNumber();
      var TabThemes = [];
      ProNum++;
      var product
      if (this.detailsElement.typeArticle == "vetements") {
        product = {
          nb: this.model.quantite,
          taille: this.selectDetailsSize,
          couleur: this.colorImg,
          id: id,
        };
      } else if (this.detailsElement.typeArticle == "chaussure") {
         product = {
          nb: this.model.quantite,
          pointure: this.selectDetailsPointure,
          couleur: this.colorImg,
          id: id,
        };
      } else if (this.detailsElement.typeArticle == "tapis") {
        product = {
          nb: this.model.quantite,
          largeur: this.dimmensionLargeur,
          longueur: this.dimmensionLongueur,
          couleur: this.colorImg,
          id: id,
        };
      } else if (this.detailsElement.typeArticle == "autre") {
        product = {
          nb: this.model.quantite,
          couleur: this.colorImg,
          id: id,
        };
      }
      localStorage.setItem("ProductNumber", ProNum);
      localStorage.setItem("product" + ProNum, JSON.stringify(product));
      console.log(
        "object",
        JSON.parse(localStorage.getItem("product" + ProNum))
      );
      this.getElements();
      this.$toast.open({
        message: "Produit bien ajouté au Panier",
        type: "success",
      });
      for (var k = 1; k <= ProNum; k++) {
        TabThemes.push(localStorage.getItem("product" + k));

      }
      this.$store.commit("setbasket", TabThemes);
    },
    productBtnMore() {
      if (this.allArticles.length > 16) {
        return true;
      } else {
        return false;
      }
    },
    verifImg(img) {
      if (
        img.includes(
          "https://res.cloudinary.com/dpy824jnw/image/upload/v1604061374/undefined"
        )
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
};
